<template>
	<div class="flex" @click="modal.show()">
		<slot name="select" />
	</div>

	<ModalItem ref="modal">
		<Page>
			<template v-for="(option, id) in props.options" :key="id">
				<div
					@click="
						emit('selected', option);
						modal.hide();
					"
				>
					<slot name="option" v-bind="option" />
				</div>
			</template>
		</Page>
	</ModalItem>
</template>

<script setup lang="ts" generic="T">
import ModalItem from '@/components/ModalItem.vue';
import { ref, defineComponent } from 'vue';
import Page from './Page.vue';

const props = defineProps<{
	options: T[];
}>();

const modal = ref();

const emit = defineEmits<{
	(e: 'selected', data: T): void;
}>();
</script>

<style scoped>
.select-list {
	display: flex;
	flex-direction: column;
}
</style>
